import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function alreadyExistingValidator(existingDates?: Date[]): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		const date = new Date(control.value);
		const value = date.getTime();

		if (!value || !existingDates?.length) {
			return null;
		}

		const exists = existingDates.some((d) => new Date(d).setHours(0, 0, 0, 0) === date.setHours(0, 0, 0, 0));

		return exists ? { alreadyExisting: true } : null;
	};
}
